import { Controller } from '@hotwired/stimulus'

import 'tui-time-picker/dist/tui-time-picker'
import 'tui-calendar/dist/tui-calendar.css'
import Calendar from 'tui-calendar'
import holidayJp from '@holiday-jp/holiday_jp'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.css'
import { Japanese } from 'flatpickr/dist/l10n/ja'
import dayjs from 'dayjs'

flatpickr.localize(Japanese)
export default class extends Controller {
  rentalRoomCalendar = new Calendar(document.getElementById('rental_room'), {
    id: '100',
    name: 'My Calendar',
    defaultView: 'month',
    isReadOnly: true,
    scheduleView: 'allday',
    useCreationPopup: false,
    useDetailPopup: true,
    // isAllday: true,
    template: {
      // popupDetailBody: function (schedule) {
      //   return `<span class="flex items-center">${icon(schedule.body)} ${message(schedule.body)}</span>`
      // },
      // allday: function (schedule) {
      //   return `<span class="flex items-center">${icon(schedule.raw.level)} ${schedule.title}</span>`
      // },
      monthGridHeader: function (dayModel) {
        const month = parseInt(dayModel.date.split('-')[1], 10)
        const date = parseInt(dayModel.date.split('-')[2], 10)
        let classNames = ['tui-full-calendar-weekday-grid-date']

        // 土曜日の日付を青色
        if (dayModel.day === 6) {
          classNames.push('text-blue-500')
        }

        // 祝日の日付を赤色
        if (holidayJp.isHoliday(new Date(dayModel.date))) {
          classNames = classNames.filter(name => name !== 'text-blue-500')
          classNames.push('text-red-500')
        }

        if (dayModel.isToday) {
          classNames.push('tui-full-calendar-weekday-grid-date-decorator')
          return month + '/' + '<span id="today-circle" class="' + classNames.join(' ') + '">' + date + '</span>'
        }

        return '<span class="' + classNames.join(' ') + '">' + month + '/' + date + '</span>'
      }
    },
    month: {
      daynames: ['日', '月', '火', '水', '木', '金', '土'],
      startDayOfWeek: 0,
      narrowWeekend: false,
      isAlways6Week: false,
      visibleScheduleCount: 6
    }
  })

  static values = {
    schedules: Array,
    rentalRoom: Array,
    workers: Array,
    designationTypes: Array,
    rentalServices: Array,
    currentUserId: String,
    start: String,
    isCustomer: Boolean
  }

  connect () {
    this.getCalendarData()
  }

  getCalendarData () {
    this.rentalRoomCalendar.setDate(this.startValue)
    this.schedulesValue.forEach((schedule, index) => {
      const color = this.dotColor(schedule)
      let cancelMessage = ''
      const isCanceled = (schedule.canceled_at !== null)
      const isWaiting = (schedule.is_waiting)
      if (isCanceled) {
        cancelMessage = '[キャンセル] '
      }
      const isPast = dayjs().isAfter(dayjs(schedule.start_at))
      // signage_company, paramsは入力しないと保存できないが、古いデータ対応のためnullチェック
      const signageInfo = `案内板表示: ${schedule.signage_company || ''} ${schedule.signage_person || ''}${schedule.signage_person_suffix || ''}`
      let workers = ''
      if (schedule.workers && schedule.workers.length > 0) {
        workers = `<br>ご希望スタッフ: ${schedule.workers.join(', ')}`
      }
      let fixedWorkers = ''
      if (schedule.worker_status) {
        const badge = this.setWorkerBadge(schedule.worker_status)
        fixedWorkers = `<br>調整済みスタッフ: <span class="badge badge-sm badge-outline p-2 ${badge.class}">${badge.name}</span> ${schedule.fixed_workers?.join(', ')}`
      }
      let services = ''
      if (schedule.services && schedule.services.length > 0) {
        services = `<br>オプションサービス: ${schedule.services.join(', ')}`
      }
      let hasOutsideWorker = ''
      if (schedule.has_outside_worker) {
        hasOutsideWorker = '<br>※外部スタッフ作業'
      }
      let note = ''
      if (schedule.note !== null) {
        note = `<br>備考: ${schedule.note}`
      }
      let recipients = ''
      if (schedule.recipients && schedule.recipients.length > 0) {
        recipients = `<br>通知先: ${schedule.recipients.map(user => user.name).join(', ')}`
      }
      const path = this.currentUserIdValue === String(schedule.user_id) ? '/info' : ''
      this.rentalRoomCalendar.createSchedules([
        {
          id: schedule.id,
          category: 'time',
          start: new Date(schedule.start_at),
          end: new Date(schedule.end_at),
          location: `<a href="${schedule.room_url}" target="_blank" rel="noopener noreferrer" class="underline">${schedule.room_name}</a>`,
          borderColor: color,
          bgColor: color,
          title: `${cancelMessage}${dayjs(schedule.start_at).format('HH:mm')} - ${dayjs(schedule.end_at).format('HH:mm')} ${schedule.name}`,
          attendees: [schedule.user_name],
          body: `${signageInfo}${workers}${fixedWorkers}${hasOutsideWorker}${note}${services}${recipients}</div>
                <div><a class="underline" href="/rental_room_reservations/${schedule.id}${path}">詳細</a></div>
                <div>${this.editButton(schedule.cancelable, isCanceled, isPast, schedule.id, schedule)}</div>
                <div>${this.cancelButton(schedule.cancelable, isCanceled, isPast, schedule.id)}</div>
                <div>${this.cancelWaitButton(schedule.cancelable, isCanceled, isPast, schedule.id, isWaiting)}</div>`
        }
      ])
    })
  }

  dotColor (schedule) {
    if (schedule.canceled_at) return '#FFFFFF'
    const colorWorkerStatus = schedule.worker_status === 'adjusting' ? '#f87171' : '#4ade80'
    // adminの場合はキャンセル待ちより調整ステータスが優先されます
    if (!this.isCustomerValue) return colorWorkerStatus
    if (this.currentUserIdValue === String(schedule.user_id)) return colorWorkerStatus
    if (schedule.is_waiting) return '#9ca3af'

    return '#FFFFFF'
  }

  setWorkerBadge (status) {
    switch (status) {
      case 'adjusting':
        return { class: 'badge-secondary', name: '調整中' }
      case 'fixed':
        return { class: 'badge-primary', name: '調整済み' }
      case 'alternative':
        return { class: 'badge-warning', name: '別スタッフ' }
      case 'nonadjustable':
        return { class: 'bg-gray-200 text-black', name: 'スタッフなし' }
      default:
        return { class: '', name: '' }
    }
  }

  editButton (cancelable, canceled, isPast, id, schedule) {
    if (cancelable === false) { return '' }
    if (canceled === true) { return '' }
    if (isPast === true) { return '' }
    return `<div data-controller="rental-room-entry-edit"
                 data-rental-room-entry-edit-entry-value='${JSON.stringify(schedule)}'
                 data-rental-room-entry-edit-rooms-value='${JSON.stringify(this.rentalRoomValue)}'
                 data-rental-room-entry-edit-workers-value='${JSON.stringify(this.workersValue)}'
                 data-rental-room-entry-edit-designation-types-value='${JSON.stringify(this.designationTypesValue)}'
                 data-rental-room-entry-edit-rental-services-value='${JSON.stringify(this.rentalServicesValue)}'
                 data-rental-room-entry-edit-current-user-id-value='${this.currentUserIdValue}'
            >
              <div data-rental-room-entry-edit-target="dialogButton"></div>
            </div>`
  }

  cancelButton (cancelable, canceled, isPast, id) {
    if (cancelable === false) { return '' }
    if (canceled === true) { return '' }
    if (isPast === true) { return '' }

    return `<div data-controller="modal">
              <button data-action="click->modal#open" class="btn btn-outline btn-sm btn-accent mt-2">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-1 h-4 w-4">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
                キャンセル
              </button>
              <div data-modal-target="container"
                 data-action="click->modal#closeBackground"
                 class="z-10 hidden grid grid-cols-12 py-20 animated fadeIn fixed inset-0 overflow-y-auto flex items-center justify-center bg-gray-900/50 overflow-auto">
                <div class="col-span-6 col-start-4">
                  <div class="bg-white shadow-xl">
                    <div class="p-8 px-16 text-lg">
                      <div class="flex justify-center text-3xl font-semibold text-gray-800 mb-4">会議室</div>
                      <div class="border-t border-gray-200 py-5"></div>
                      <div class="flex justify-center">予約をキャンセルしてもよろしいですか？</div>
                      <div class="flex flex-row justify-center items-center mt-10">
                        <button data-action="click->modal#close" class="btn btn-md text-white border-gray-500 bg-gray-500 hover:border-gray-600 hover:bg-gray-600">戻る</button>
                        <a class="btn btn-md btn-accent text-white ml-2"
                          rel="nofollow" data-method="post"
                          href="/rental_room_reservations/${id}/cancellation">
                          確定
                        </a>
                      </div>
                      <div class="flex flex-col justify-center items-center mt-6 text-sm text-gray-800">
                        <div>前日18時以降キャンセル：キャンセル料50％</div>
                        <div>当日8時以降キャンセル：キャンセル料100％</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>`
  }

  cancelWaitButton (cancelable, canceled, isPast, id, isWaiting) {
    if (cancelable === true) { return '' }
    if (canceled === true) { return '' }
    if (isPast === true) { return '' }
    if (isWaiting === true) { return '' }

    return `<div data-controller="modal">
              <button data-action="click->modal#open" class="btn btn-outline btn-sm text-sky-500 border-sky-500 hover:text-white hover:border-sky-400 hover:bg-sky-400 mt-2">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
                </svg>
                キャンセル待ち
              </button>
              <div data-modal-target="container"
                 data-action="click->modal#closeBackground"
                 class="z-10 hidden grid grid-cols-12 py-20 animated fadeIn fixed inset-0 overflow-y-auto flex items-center justify-center bg-gray-900/50 overflow-auto">
                <div class="col-span-6 col-start-4">
                  <div class="bg-white shadow-xl">
                    <div class="p-8 px-16 text-lg">
                      <div class="flex justify-center text-3xl font-semibold text-gray-800 mb-4">会議室</div>
                      <div class="border-t border-gray-200 py-5"></div>
                      <div class="flex justify-center">キャンセル待ち登録してよろしいですか？</div>
                      <div class="flex flex-col justify-center items-center mt-6 text-sm text-gray-800">
                        <div>キャンセルされた際にメールにて通知されます。会議室を予約する場合は、SMART BOOKINGから再度ご予約ください。</div>
                      </div>
                      <div class="flex flex-row justify-center items-center mt-10">
                        <button data-action="click->modal#close" class="btn btn-md text-white border-gray-500 bg-gray-500 hover:border-gray-600 hover:bg-gray-600">戻る</button>
                        <button data-action="click->modal#postWaitlist" id=${id} class="btn btn-md text-white border-green-500 bg-green-500 hover:border-green-600 hover:bg-green-600 md:btn-md ml-2">
                          登録
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>`
  }
}
